"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.typography = exports.TYPOGRAPHY_VARIANTS = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
/* eslint-disable sort-keys */

// type AllVariants = TypographyVariant | 'p8';

var TYPOGRAPHY_VARIANTS = exports.TYPOGRAPHY_VARIANTS = ['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'subtitle1', 'subtitle2', 'body1', 'body2', 'button', 'caption', 'overline'
// 'p8',
];

// Tell Material-UI what's the font-size on the html element.
// 16px is the default font-size used by browsers.
var htmlFontSize = 16; // 16 default
var pxToRem = function pxToRem(size) {
  return "".concat(size / htmlFontSize, "rem");
};
var fontFamily = 'Roboto';
var fontSize = 14; // 14 default
var fontWeightLight = 400; // 300 default
var fontWeightRegular = 400; // 400 default
var fontWeightMedium = 600; // 500 default (set to SemiBold)
var fontWeightSemiBold = 600; // IM (added)
var fontWeightBold = 700; // 700 default

var baseValues = {
  htmlFontSize: htmlFontSize,
  pxToRem: pxToRem,
  fontFamily: fontFamily,
  fontSize: fontSize,
  fontWeightLight: fontWeightLight,
  fontWeightRegular: fontWeightRegular,
  fontWeightMedium: fontWeightMedium,
  fontWeightSemiBold: fontWeightSemiBold,
  fontWeightBold: fontWeightBold
};
var ImTypography = {
  title: {
    // fontFamily,
    fontSize: '1.5rem',
    fontWeight: fontWeightSemiBold,
    lineHeight: '36px'
  },
  subtitle: {
    // fontFamily,
    fontSize: '1.125rem',
    fontWeight: fontWeightSemiBold,
    lineHeight: '26px'
  },
  bodyText: {
    // fontFamily,
    fontSize: '1rem',
    fontWeight: fontWeightRegular,
    lineHeight: '24px'
  },
  secondaryText: {
    // fontFamily,
    fontSize: '0.875rem',
    fontWeight: fontWeightRegular,
    lineHeight: '21px'
  }
};
var typography = exports.typography = (0, _extends2["default"])({}, baseValues, {
  h1: {},
  h2: {},
  h3: {},
  h4: {},
  h5: (0, _extends2["default"])({}, ImTypography.title),
  h6: {},
  // Used for Field Labels
  subtitle1: (0, _extends2["default"])({}, ImTypography.subtitle),
  subtitle2: (0, _extends2["default"])({}, ImTypography.subtitle),
  body1: (0, _extends2["default"])({}, ImTypography.bodyText),
  body2: (0, _extends2["default"])({}, ImTypography.secondaryText),
  button: {
    fontSize: '1.125rem',
    fontWeight: fontWeightRegular,
    lineHeight: '24px'
    // textTransform: 'uppercase', // Same as MUI
  },
  caption: {},
  overline: {}
});